// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../imgs/blob-blue-duo-2x.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QOcYZLzvPePhJsYOJJS4 {
  background-color: var(--secondary-alt-color);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position-x: right;
  background-position-y: 10%;
  background-size: auto 90%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2rem;
  color: var(--white-color);
}

.ChLG0Q1D2r10a8ltQ9pd a {
  font-weight: bold;
  color: var(--white-color);
  transition: color 0.3s ease;
}

.ChLG0Q1D2r10a8ltQ9pd a:hover {
  color: var(--primary-color);
  cursor: pointer;
}

.ChLG0Q1D2r10a8ltQ9pd h1 {
  font-size: var(--step-2);
  line-height: var(--base-line-height);
}

.ChLG0Q1D2r10a8ltQ9pd h2 {
  font-size: var(--step-1);
  line-height: var(--base-line-height);
}

.ChLG0Q1D2r10a8ltQ9pd p {
  text-wrap: balance;
  padding-top: 1rem;
  padding-bottom: 2rem;
  font-size: var(--step-0);
  line-height: var(--base-line-height);
}

.ChLG0Q1D2r10a8ltQ9pd li {
  padding-bottom: 1rem;
  font-size: var(--step-0);
  line-height: var(--base-line-height);
}

@media only screen and (min-width: 750px) {
  .QOcYZLzvPePhJsYOJJS4 {
    padding: 1rem;
  }

  .ChLG0Q1D2r10a8ltQ9pd {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .cioVLrEZZopEfiCOHExP {
    width: 60%;
    text-align: left;
  }

  .DVGCekRH846j_EDvQZLr {
    width: 60%;
    text-align: left;
  }

  .OM2rTqH94aKWlowpuyZE {
    width: 60%;
    text-align: left;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AboutPage/AboutPage.css"],"names":[],"mappings":"AAAA;EACE,4CAA4C;EAC5C,yDAAsD;EACtD,4BAA4B;EAC5B,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;AACF","sourcesContent":[".aboutSection {\n  background-color: var(--secondary-alt-color);\n  background-image: url(../../imgs/blob-blue-duo-2x.png);\n  background-position-x: right;\n  background-position-y: 10%;\n  background-size: auto 90%;\n  background-repeat: no-repeat;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 2rem;\n  color: var(--white-color);\n}\n\n.sectionContent a {\n  font-weight: bold;\n  color: var(--white-color);\n  transition: color 0.3s ease;\n}\n\n.sectionContent a:hover {\n  color: var(--primary-color);\n  cursor: pointer;\n}\n\n.sectionContent h1 {\n  font-size: var(--step-2);\n  line-height: var(--base-line-height);\n}\n\n.sectionContent h2 {\n  font-size: var(--step-1);\n  line-height: var(--base-line-height);\n}\n\n.sectionContent p {\n  text-wrap: balance;\n  padding-top: 1rem;\n  padding-bottom: 2rem;\n  font-size: var(--step-0);\n  line-height: var(--base-line-height);\n}\n\n.sectionContent li {\n  padding-bottom: 1rem;\n  font-size: var(--step-0);\n  line-height: var(--base-line-height);\n}\n\n@media only screen and (min-width: 750px) {\n  .aboutSection {\n    padding: 1rem;\n  }\n\n  .sectionContent {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .sectionOne {\n    width: 60%;\n    text-align: left;\n  }\n\n  .sectionTwo {\n    width: 60%;\n    text-align: left;\n  }\n\n  .sectionThree {\n    width: 60%;\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aboutSection": `QOcYZLzvPePhJsYOJJS4`,
	"sectionContent": `ChLG0Q1D2r10a8ltQ9pd`,
	"sectionOne": `cioVLrEZZopEfiCOHExP`,
	"sectionTwo": `DVGCekRH846j_EDvQZLr`,
	"sectionThree": `OM2rTqH94aKWlowpuyZE`
};
export default ___CSS_LOADER_EXPORT___;
